import React, { useEffect } from "react";
import { Card, Table, Layout, Form, Space, Button, Col, Select } from "antd";
import { observer } from "mobx-react";
import { useHistory, useLocation } from "react-router-dom";
import { FilterBar } from "../../../components/filter/FilterBar";
import { fmtDate2 } from "../../../common/Utils";
import { channelInvitationsStore } from "../../../store/invitation/ChannelInvitationsStore";
import { Toolbar } from "../../../components/Toolbar";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { ChannelInvitationDlg } from "./ChannelInvitationDlg";

export const ChannelInvitations = observer(() => {
  const location = useLocation();
  const history = useHistory();

  const store = channelInvitationsStore;

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };
  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Campaign Name",
      dataIndex: "name",
    },
    {
      title: "Code",
      dataIndex: "code",
    },
    {
      title: "Community",
      dataIndex: ["community", "name"],
    },
    {
      title: "Status",
      dataIndex: "state",
    },
    {
      title: "Creation Date",
      dataIndex: "createDate",
      render: fmtDate2,
    },
    {
      title: "Registered Invitee Count",
      dataIndex: "invitedCount",
    },
    {
      title: "Notes",
      dataIndex: "notes",
    },
    {
      title: "",
      render: (_, r) => (
        <Space>
          <EditOutlined onClick={() => store.edit.edit(r)} />
        </Space>
      ),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <Toolbar
        actions={
          <Button
            type="primary"
            size="large"
            icon={<PlusOutlined />}
            onClick={() => store.edit.edit({ state: "Active" } as any)}
          >
            New Invitation
          </Button>
        }
      ></Toolbar>

      <FilterBar store={store} actionsSpan={8}>
        <Col span={8}>
          <Form.Item label="Status">
            <Select style={{ width: "100%" }} value={store.filter.status} onChange={(e) => (store.filter.status = e)}>
              <Select.Option value="" key="">
                All
              </Select.Option>
              <Select.Option value="Active" key="Active">
                Active
              </Select.Option>
              <Select.Option value="Retired" key="Retired">
                Retired
              </Select.Option>
            </Select>
          </Form.Item>
        </Col>
      </FilterBar>

      <Card size="small" style={{ marginTop: 16 }}>
        <Table
          size="small"
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          rowKey="id"
          columns={columns}
          dataSource={store.data.items}
        />
      </Card>
      {store.edit.visible && <ChannelInvitationDlg />}
    </Layout.Content>
  );
});
